import { render, staticRenderFns } from "./Payer.vue?vue&type=template&id=b05679a6"
import script from "./Payer.vue?vue&type=script&lang=js"
export * from "./Payer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports